import React, { useEffect, useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { ITaskGroup } from '../../../models/taskGroup.types';
import { addExamTaskGroupCoordinator } from '../../../services/exams/examiningTeam/examiningTeam.service';
import { AxiosError } from 'axios';

export const AddKGZPrompt: React.FC<{
  taskGroup: ITaskGroup;
  onSuccess: () => void;
  onFailure: () => void;
}> = (props) => {
  const [openFailurePrompt, setOpenFailurePrompt] = useState<boolean>(false);

  const createNewKGZ = () => {
    addExamTaskGroupCoordinator(props.taskGroup.taskGroupId).then(
      () => props.onSuccess(),
      (error: AxiosError) => {
        setOpenFailurePrompt(true);
        console.log(error);
      },
    );
  };

  useEffect(() => {
    if (props.taskGroup) {
      createNewKGZ();
    }
  }, []);

  const getPromptSubTexts = () => {
    return [
      { text: props.taskGroup.name },
      {
        text: 'nie powiodło się, spróbuj ponownie później.',
        isBold: true,
      },
    ];
  };

  return (
    <>
      <Prompt
        type="error"
        isBold={true}
        open={openFailurePrompt}
        mainText={'Dodanie funkcji KGZ dla:'}
        subTexts={getPromptSubTexts()}
        onConfirm={props.onFailure}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};

export default AddKGZPrompt;
